export const INTERVAL = 3000;
export const DURATION_OF_ANIMATION = 0.5;
export const DURATION_OF_DISABLING_ANIMATION = (DURATION_OF_ANIMATION * 1000) / 2;
export const DEFAULT_SHOW_INDEX = 1;
export const MIN_LEFT_POSITION = -25;
export const MIN_LEFT_POSITION_FOR_LANDSCAPE = -19;
export const EDGE = 2;
